module.exports = __webpack_public_path__ + "static/media/girl-7.474bf9b9.svg";